import axios from "axios";

export default {
    deleteContract: async (id) => {
        await axios.delete(`/contracts/${id}`)
    }
}
